import { render, staticRenderFns } from "./IconTemplate.vue?vue&type=template&id=a7ae6dc2&scoped=true"
import script from "./IconTemplate.vue?vue&type=script&lang=js"
export * from "./IconTemplate.vue?vue&type=script&lang=js"
import style0 from "./IconTemplate.vue?vue&type=style&index=0&id=a7ae6dc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ae6dc2",
  null
  
)

export default component.exports